'use client';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { currentCheckoutVehicleAtom } from '@core/Atoms/Vehicle/CurrentCheckoutVehicle.atom';
import { sessionStorageHelper } from '@core/Utils/SessionStorageHelper';

const DEFAULT_VALUE = {
  isLoading: true,
};

export const checkoutDataAtom = atomWithStorage<Record<string, any>>(
  'checkoutDataAtom',
  DEFAULT_VALUE,
  sessionStorageHelper,
);

export const checkoutDataByIdAtom = atom(
  get => {
    const vehicleId = get(currentCheckoutVehicleAtom)?.heycarId;
    return get(checkoutDataAtom)?.[vehicleId as string];
  },
  (get, set, value: any) => {
    const vehicleId = get(currentCheckoutVehicleAtom)?.heycarId;
    const checkoutData = get(checkoutDataAtom);
    const checkoutDataById = checkoutData?.[vehicleId as string];
    set(checkoutDataAtom, {
      ...checkoutData,
      isLoading: false,
      [vehicleId as string]: {
        ...checkoutDataById,
        ...value,
      },
    });
  },
);

export const resetCheckoutDataAtom = atom(
  get => get(checkoutDataByIdAtom),
  (get, set) => {
    const vehicleId = get(currentCheckoutVehicleAtom)?.heycarId;
    const checkoutData = get(checkoutDataAtom);
    const resetData = {
      isLoading: false,
    };

    return set(checkoutDataAtom, {
      ...checkoutData,
      [vehicleId as string]: resetData,
    });
  },
);

export const hasCheckoutDataLoadedAtom = atom(get => !get(checkoutDataAtom).isLoading);
